import ChangeReasonModal from '../change-reason-modal/change-reason-modal';
import EnterDataFormComponent from './enter-data-form-component';
import EnterDataFormService from './enter-data-form-service';
import EnterDataFormInput from '../enter-data-form-input/enter-data-form-input';

/***
 * The master data entry form. Contains error messages, success messages, last-updated timestamps,
 * and renders the form based on form metadata returned by the server.
 */
const enterDataForm = angular
    .module('FacilityData.EnterData.EnterDataForm', [
        ChangeReasonModal,
        EnterDataFormInput
    ])
    .component('enterDataForm', EnterDataFormComponent)
    .service('EnterDataFormService', EnterDataFormService)
    .name;

export default enterDataForm;


// WEBPACK FOOTER //
// ./app/components/enter-data/enter-data-form/enter-data-form.js